import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface EmptyStateProps {
  message?: string;
}

export const EmptyState = ({ message = '아직 내용이 없습니다.' }: EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 200px)',
        color: '#888',
        gap: 1
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 48, opacity: 0.5 }} />
      <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
        {message}
      </Typography>
    </Box>
  );
}; 